import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DialpadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dialpad"}/>
}
